exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".model-view[data-v-67b6a8af]{width:100%;height:100%}", ""]);

// exports
